const data = [
    {
        id:'black-belt',
        title:'Lord of Tatami',
        info:'After years of practing, you now own the legendary black belt of Karate: people are afraid of you and you win battles without even fighting! GG WP',
        icon:"black_belt.svg",
        score:'Completed',
        date:'2010'
    },
    {
        id:'nhsmun',
        title:'The ambassador',
        info:'You participated in the Italian Model United Nations (IMUN) as a delegate of United Arab Emirates at FAO Headquarters in Rome and in the National High School Model United Nations (NHSMUN) as delegate of Angola in the ECOFIN council at United Nations Headquarters in New York.<br><a href="/IMUN.pdf" target="_blank">IMUN Certificate</a><br> <a href="/NHSMUN.pdf" target="_blank">NHSMUN Certificate</a>',
        icon:"nhsmun.svg",
        score:'Completed',
        date:'2012'
    },
    {
        id:'erasmus',
        title:'Foreign Legion',
        info:'The time has come! Start a new adventure on your own in Bratislava (Slovakia) for the Erasmus program. Learn to cook or die trying! <a href="/erasmus">More details</a>',
        icon:"slovakia.svg",
        score:'Completed',
        date:'2020',
    },

]

export default data;